import ThirdBlock from "./third-block";

export default ThirdBlock